export const blockIconsAudioandvideoEqualizer = (
	<span className='material-symbols-outlined'>equalizer</span>
);
